import { Option } from '../../types/Option/Option';
import { UnitTour } from '../../types/Unit/Unit';
import { FilterableProperty } from '../../types/FilterableProperty/FilterableProperty';

export default function getFilterOptions(
    data: UnitTour[],
    propertyName: Exclude<FilterableProperty, 'unitSize'>
): Option[] {
    const optionsMap = data.reduce((acc, d) => {
        const optionValue = d[propertyName];

        if (
            optionValue === undefined ||
            optionValue === null ||
            optionValue === ''
        )
            return acc;

        acc.set(optionValue, `${optionValue}`);
        return acc;
    }, new Map<number | string, string>());

    return [...optionsMap]
        .sort(([firstKey], [secondKey]) => (firstKey > secondKey ? 1 : -1))
        .map(([key, displayName]) => ({ key, displayName }));
}
